.e{flex-direction:column;}